import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateRangeInput from 'components/input/DateRange/DateRangeInput';
import dateUtils from 'helpers/dateUtils';
import { compose } from 'recompose';
import { Field, Form, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { INTERVAL_BY_HOUR } from 'helpers/graph';

class ProductOccupancyForm extends Component {
    componentDidMount() {
        const { initialize } = this.props;

        initialize({
            from: dateUtils.formatDate(new Date()),
            interval: INTERVAL_BY_HOUR,
            to: dateUtils.formatDate(new Date()),
        });
    }

    onChange = (...values) => {
        const { change } = this.props;
        const from = values[0];
        const to = values[1];

        change('from', dateUtils.formatDate(from));
        change('to', dateUtils.formatDate(to));
    }

    render() {
        const {
            from,
            to,
        } = this.props.formValues;

        return (
            <Form onSubmit={ () => {} } style={ { minWidth: 200 } }>
                <Field
                    component={ DateRangeInput }
                    defaultValue={ [
                        from,
                        to,
                    ] }
                    label=''
                    name='date'
                    onAccept={ this.onChange }
                    source='products'
                    type='date'
                />
            </Form>
        );
    }
}

ProductOccupancyForm.propTypes = {
    change: PropTypes.func.isRequired,
    formValues: PropTypes.shape({
        from: PropTypes.string,
        interval: PropTypes.string,
        to: PropTypes.string,
    }),
    initialize: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const selector = formValueSelector(props.form);

    return {
        formValues: selector(state, 'from', 'to'),
    };
};

const enhance = compose(
    connect(mapStateToProps, null),
    reduxForm(),
);

export default enhance(ProductOccupancyForm);


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/input/ProductOccupancyForm.js